export default {
  'meta': {
    'langName': 'ENGLISH',
    'lang': 'English'
  },
  'title': 'PRODUCT RECALL BASKETBALL HOOP B900 BOX NBA TARMAK',
  'description': 'We have identified a risk of the pole falling on our B900 basketball hoop if it is used without its handle and manipulated.\nFor your safety, immediately stop all use without its height adjustment handle installed.\nSecuring your product will be possible with a simple procedure and a repair kit that will be delivered to you free of charge.\nThis website dedicated to this recall is currently under construction. It will guide you through the steps to perform this operation.\nWe will inform you as soon as it is available (during July).',
  'status': 'Translation validated by SPORT'
} as const
